import * as React from 'react'

export const CodeIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.682 8.08179C29.7417 8.39346 30.3481 9.50517 30.0364 10.5649L21.8011 38.5649C21.4894 39.6245 20.3777 40.2309 19.318 39.9193C18.2583 39.6076 17.652 38.4959 17.9636 37.4362L26.1989 9.43619C26.5106 8.3765 27.6223 7.77012 28.682 8.08179Z"
        fill="#0070E0"
      />
      <path
        d="M37.1717 24.0007L32.225 28.9473C31.4439 29.7283 31.4439 30.9946 32.225 31.7757C33.006 32.5567 34.2723 32.5568 35.0534 31.7757L41.4143 25.4149C42.1954 24.6339 42.1954 23.3675 41.4143 22.5865L35.0534 16.2255C34.2723 15.4444 33.006 15.4444 32.2249 16.2255C31.4439 17.0065 31.4439 18.2729 32.2249 19.0539L37.1717 24.0007Z"
        fill="#0070E0"
      />
      <path
        d="M15.7751 28.9473L10.8284 24.0007L15.7752 19.0539C16.5562 18.2729 16.5562 17.0065 15.7752 16.2255C14.9941 15.4444 13.7278 15.4444 12.9468 16.2255L6.58579 22.5865C5.80473 23.3675 5.80474 24.6339 6.5858 25.4149L12.9467 31.7757C13.7278 32.5568 14.9941 32.5567 15.7752 31.7757C16.5562 30.9946 16.5562 29.7283 15.7751 28.9473Z"
        fill="#0070E0"
      />
    </svg>
  )
})

CodeIcon.displayName = 'CodeIcon'
